import { type MutableRefObject, useEffect, useRef } from 'react';

export function usePaymentScript(): void {
	const isScriptInjectedRef: MutableRefObject<boolean> = useRef(false);

	useEffect(() => {
		if (!isScriptInjectedRef.current) {

			const script = document.createElement('script');
			script.src = 'https://widget.cloudpayments.ru/bundles/cloudpayments.js';
			script.async = true;
			document.head.appendChild(script);

			isScriptInjectedRef.current = true;
		}
	}, []);
}
